<template>
  <div style="margin: 0 0 24px;">
    <div style="display: flex; align-items: center">
<!--      <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 340px;height: 340px;margin: 0 auto">-->
      <el-image v-if="src" style="width: 340px;height: 340px;margin: 0 auto; cursor: pointer" fit="cover" :src="src" @click="headImgUpdate" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      <div class="add" @click="headImgUpdate" v-else>
        <span>+</span>
      </div>
      <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { uploadShopImg, getSysPositionList } from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";
import Dialog from "@/assets/js/dialog";
import MapDialog from "@/views/shop/components/MapDialog";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      shopForm: this.value.shopForm,

      files: null,
      src: this.value.shopForm.img,

      loading: false

    }
  },
  methods: {

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '门店照片不能为空',
          type: 'warning'
        });
        return false
      }

      this.loading = true
      let param = new FormData();
      param.append('id', this.shopForm.id);
      param.append('file', this.files);

      imgPostFormData(uploadShopImg, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', this.src)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 340px;
  height: 340px;
  text-align: center;
  line-height: 340px;
  border: 2px dashed #ececec;
  font-size: 40px;
  cursor: pointer;
  margin: 0 auto
}
</style>
